/* Cardivie (TM) - tous les CTA renvoient vers la section "Informations produit" + le selecteur de quantite */
(function () {
  'use strict';

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function animateTo(targetY, duration, done) {
    var startY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var delta = targetY - startY;
    if (Math.abs(delta) < 2) { if (done) done(); return; }
    var start = null;
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      window.scrollTo(0, targetY);
      if (done) done();
    }
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / duration);
      window.scrollTo(0, startY + delta * easeInOutCubic(p));
      if (p < 1) { window.requestAnimationFrame(step); } else { finish(); }
    }
    window.requestAnimationFrame(step);
    // repli : si rAF ne tourne pas (onglet masque), on saute directement
    setTimeout(function () {
      var now = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (Math.abs(now - startY) < 2) finish();
    }, duration + 120);
  }

  function offsetOf(el) {
    var y = 0;
    var node = el;
    while (node) { y += node.offsetTop || 0; node = node.offsetParent; }
    return y;
  }

  function headerOffset() {
    var h = document.querySelector('.section-header, header.header-wrapper, sticky-header, #shopify-section-header');
    if (!h) return 16;
    var r = h.getBoundingClientRect();
    var sticky = window.getComputedStyle(h).position;
    return (sticky === 'sticky' || sticky === 'fixed') ? r.height + 16 : 16;
  }

  function mainSection() {
    var m = document.querySelector('[id^="MainProduct-"]');
    if (m) return m.closest('.shopify-section') || m;
    var q = document.querySelector('.quantity-breaks-container');
    return q ? (q.closest('.shopify-section') || q) : null;
  }

  function flash(el) {
    if (!el) return;
    el.style.transition = 'box-shadow .35s ease';
    var i = 0;
    var t = setInterval(function () {
      el.style.boxShadow = (i % 2 === 0) ? '0 0 0 3px rgba(239,68,68,.55)' : '0 0 0 0 rgba(239,68,68,0)';
      if (++i > 5) { clearInterval(t); el.style.boxShadow = ''; }
    }, 340);
  }

  function go() {
    var section = mainSection();
    if (!section) return;
    var off = headerOffset();
    animateTo(Math.max(0, offsetOf(section) - off), 620, function () {
      var qty = document.querySelector('.quantity-breaks-container')
        || document.querySelector('.product-form__quantity')
        || document.querySelector('variant-radios, variant-selects');
      if (!qty) return;
      var y = Math.max(0, offsetOf(qty) - off - 24);
      animateTo(y, 420, function () { flash(qty); });
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-cvi-scroll]') : null;
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    go();
  }, true);
})();
